/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateEmailChangeDataParser = 
/* #__PURE__ */ parsers.object([
    ['newEmail', codecString, 'new_email'],
    ['oldPassword', /* #__PURE__ */ codecOptional(codecString), 'old_password'],
]);
export class CreateEmailChangeData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateEmailChangeDataParser.decode(input).map(res => new CreateEmailChangeData(res));
    }
    static unsafeDecode(input) {
        return CreateEmailChangeData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateEmailChangeDataParser.encode(data);
    }
    static schema() {
        return CreateEmailChangeDataParser.schema();
    }
}
